<template>
  <div class="sm-plaid-wrap">
    <plaid-link
      clientName="Spheremail"
      :env="plaidSettings.env"
      :products="plaidSettings.products"
      :token="linkToken"
      :onLoad="onLoad"
      :onSuccess="onSuccess"
      :onExit="onExit"
      :onEvent="onEvent"
    >
      <slot name="button" />
    </plaid-link>
  </div>
</template>

<script>
import PlaidLink from 'vue-plaid-link';
import BankSettings from '@/settings/bank-account';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'plaid-wrap',
  components: {
    'plaid-link': PlaidLink
  },
  props: {
    linkToken: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showSpinner: false
    }
  },
  computed: {
    ...mapGetters({
      isDev: 'isDev',
    }),
    plaidSettings() {
      return this.isDev ? BankSettings.plaid.dev : BankSettings.plaid.prod;
    }
  },
  created() {

  },
  methods: {
    onSuccess(public_token, data) {
      if (this.isDev)
        console.log('plaid success', public_token, data);

      this.$emit('success', data);
    },
    onLoad() {
      if (this.isDev)
        console.log('plaid loaded');
    },
    onExit(e, data) {
      if (this.isDev)
        console.log('exit', e, data);
    },
    onEvent(event_name, data) {
      if (this.isDev)
        console.log('event', event_name, data);
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  
  .sm-plaid-wrap {
    & > .plaid-link-wrapper {
      & > .plaid-link-button {
        @include media('<=tiny') {
          width: 100%;
        }
      }
    }
  }
</style>